<template>
  <div id="app">

    <router-view />
    <!-- 遮罩层组件 -->
 
  </div>
</template>
<script>
// import FullScreenMask from './components/FullScreenMask.vue';
import axios from 'axios';
export default {
  name: 'app',
  components: {
    // FullScreenMask
  },
  data() {
    return {
  
    };
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
   
  },
  methods: {
   
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f3f7fb;
  width: 100%;
  // min-height: 100vh;
  // height:  auto;
  color: #6a717e;
}


// 取消滚动条
::-webkit-scrollbar {
  display: none;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}


</style>
